import { render, staticRenderFns } from "./QuantifyCountryDescription.vue?vue&type=template&id=46444ea4&scoped=true"
import script from "./QuantifyCountryDescription.vue?vue&type=script&lang=js"
export * from "./QuantifyCountryDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46444ea4",
  null
  
)

export default component.exports